<ion-header class="ion-no-border" style="--background:transparent" lines="none">
  <ion-toolbar class="ion-no-border" style="--background:transparent"  lines="none">
    <ion-button shape="round" color="danger"  (click)="close()"slot="end">
      <ion-icon name="close" slot="icon-only"></ion-icon>    
    </ion-button>   
  </ion-toolbar>
</ion-header>

<ion-content>
  <swiper [config]="config" #swiper>
    <ng-template swiperSlide>
      <div class="swiper-zoom-container">
        
        <img src="{{document.PictureSrc}}"/>
      </div>
    </ng-template>
  </swiper>
</ion-content>

<ion-footer>
  <ion-row>
    <ion-col size="4" class="ion-text-center">
      <ion-button (click)="zoom(false)" shape="round" fill="solid" color="dark">
        <ion-icon name="remove" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-col>    
    <ion-col  size="4" class="ion-text-center">
      <ion-button (click)="reset()" shape="round" fill="solid" color="dark">
        <ion-icon name="search-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-col>
    <ion-col  size="4" class="ion-text-center">
      <ion-button (click)="zoom(true)" shape="round" fill="solid" color="dark">
        <ion-icon name="add" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>